import script from "./DownloadButton.vue?vue&type=script&setup=true&lang=js"
export * from "./DownloadButton.vue?vue&type=script&setup=true&lang=js"

import "./DownloadButton.vue?vue&type=style&index=0&id=a95b7eb2&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-a95b7eb2"]])

export default __exports__